import { Pill } from 'lucide-react'
import { useState } from 'react'

import ComboboxMultiSelectFilter, {
  type ComboboxFilterOption,
} from '../../reusable/table/ComboboxMultiSelectFilter'
import { type MultipleSelectedValuesFilter } from '../types'
import FilterManagementDropdown from './FilterManagementDropdown'
import { filterByLabelAndValueCallback } from './utils'

const EnrollmentTypeFilter = (props: MultipleSelectedValuesFilter) => {
  const [query, setQuery] = useState('')

  const enrollmentTypeOptions: ComboboxFilterOption<string>[] = [
    { label: 'Medical', value: 'medical' },
    { label: 'Dental', value: 'dental' },
    { label: 'Vision', value: 'vision' },
  ]

  const filteredOptions = enrollmentTypeOptions?.filter(
    filterByLabelAndValueCallback(query)
  )

  return (
    <div>
      <ComboboxMultiSelectFilter
        {...props}
        options={[{ groupLabel: 'Enrollment types', options: filteredOptions || [] }]}
        placeholder='Search enrollment types to filter...'
        onValueChange={setQuery}
      >
        <FilterManagementDropdown
          {...props}
          options={enrollmentTypeOptions || []}
          noSelectionText='Enrollment Type'
          pluralIdentifier='enrollment types'
        >
          <Pill size={20} />
        </FilterManagementDropdown>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default EnrollmentTypeFilter
